import type { ColorGroup } from "@grundbesitz/shared";
import type { AssetGroupMeta } from "../../../lib/assets";
import { GroupBadge } from "../../board/GroupBadge";

/** Group name with its color chip. Color groups use the board's patterned badge, railroads and utilities a plain chip. */
export function GroupTag({ group }: { group: AssetGroupMeta }) {
  if (group.isStreetGroup) return <GroupBadge group={group.key as ColorGroup} compact />;
  return (
    <span className="inline-flex items-center gap-1 text-xs font-medium text-ink">
      <span
        aria-hidden="true"
        className="size-3 shrink-0 rounded-[3px] border border-black/25"
        style={{ background: group.color }}
      />
      {group.name}
    </span>
  );
}
